import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input , EventEmitter, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule , FormControl } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';


//Service
import { BillsService } from '../../../services/bills.service';

//Model
import { Bill } from '../../../model/bills.model';
import { ThemeSetting } from 'src/app/model/users.model';

@Component({
    selector: 'app-billtypecreate',
    templateUrl: './billtypecreate.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [ BillsService ],
    exportAs: 'app-billtypecreate',
})
  
export class BillTypeCreateComponent implements OnInit {
    @Output() closeModal : EventEmitter<any>= new EventEmitter<any>();
    
    public s_theme: ThemeSetting;
    public spinner: boolean = false;
    public frm_bill_type: FormGroup;
    public current_user :number;

    constructor(private http: HttpClient, 
    			private _fb: FormBuilder, 
    			private modal: NgbModal, 
                private svc_bills: BillsService,
			  	private toastr: NotificationService,
                private svc_storage: LocalStorageService,
                private router : Router,
 				){
	}

    ngOnInit() {
        this.s_theme = this.svc_storage.get('themeSettings');
        this.current_user = this.svc_storage.get('user').id;
        
        this.frm_bill_type = this._fb.group({
            id: [''],
            name: ['', Validators.required],
            description: ['', Validators.required],
            created_by: [this.current_user]
        });
    }

    onSubmit(frm_value) {
        this.spinner = true;
        
        if (this.frm_bill_type.valid) {
            this.svc_bills.createBillType(frm_value).toPromise().then(result => {
                console.log(result["error"]);
                if(result["error"] == false){
                    this.toastr.showSuccess(result["message"], 'Create bill type success')
                }else{
                    this.toastr.showError(result["message"], "Create bill type error")
                }
           
                this.close(); 
            });
        }   

        this.spinner = false;
    }
    
    close(){
        this.frm_bill_type.reset();
        this.closeModal.emit();
    }

    
}